module.exports = __webpack_public_path__ + "static/media/close.d39cad51.svg";